import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChange,
} from '@angular/core';
import Product from '../../model/product/product';
import { ProductTypes } from 'src/app/model/product/product-type';
import Windowsticker from 'src/app/model/product/windowsticker/windowsticker';
import BrowserHelper from '../../helpers/browser-helper';
import ProductHelper from '../../helpers/product-helper';
import * as moment from 'moment-timezone';
import { BaseProject } from '../../model/project/base-project';
import Board from 'src/app/model/product/board/board';
import OtherProduct from 'src/app/model/product/other-product/other-product';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { AsyncChildRenderComponent } from 'src/app/subscription-helpers/async-child-render.component';

@Component({
  selector: 'product-placement-picker',
  templateUrl: './product-placement-picker.component.html',
  styleUrls: ['./product-placement-picker.component.scss'],
})
export class ProductPlacementPickerComponent
  extends AsyncChildRenderComponent
  implements OnInit, OnChanges
{
  @Input()
  public index = 0;
  @Input()
  public inputProject: BaseProject;
  @Input()
  public inputProduct: Product;
  @Output()
  public outputProduct = new EventEmitter();
  @Input()
  public isCollapsed = true;
  private collapsibleClicked = false;
  safari: boolean;

  public inputWindowsticker;
  public inputBoard: Board;
  public inputOtherProduct: OtherProduct;
  productTypeDisplay: string;
  executionDateDisplay: string;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit() {
    this.safari = BrowserHelper.isSafari();
    if (this.isWindowSticker() || this.isCustomWindowsticker()) {
      this.inputWindowsticker = <Windowsticker>this.inputProduct;
    }
    if (this.isBoard()) {
      this.inputBoard = <Board>this.inputProduct;
    }
    if (this.isOtherProduct()) {
      this.inputOtherProduct = <OtherProduct>this.inputProduct;
    }
    this.calculateType();
    this.calculateExecutionDateDisplay();
    this.addSubscription(
      this.projectDisplayObservableService.getProductExecutedSubscribable(),
      () => {
        this.calculateExecutionDateDisplay();
      }
    );
  }

  ngOnChanges(changes) {
    if (changes.isCollapsed) {
      const change: SimpleChange = changes.isCollapsed;
      if (change.currentValue === false) {
        this.collapsibleClicked = true;
        this.renderChildren.next(true);
      }
    }
  }

  isWindowSticker(): boolean {
    return this.inputProduct.type === ProductTypes.WINDOWSTICKER.value;
  }

  isCustomWindowsticker() {
    return this.inputProduct.type === ProductTypes.CUSTOMWINDOWSTICKER.value;
  }

  isBoard() {
    return this.inputProduct.type === ProductTypes.BOARD.value;
  }

  isOtherProduct() {
    return this.inputProduct.type === ProductTypes.OTHER_PRODUCT.value;
  }

  calculateType() {
    this.productTypeDisplay = ProductHelper.getTypeOf(this.inputProduct);
  }

  calculateExecutionDateDisplay() {
    if (
      this.inputProduct.productPlacement == null ||
      this.inputProduct.productPlacement.executionDate == null
    ) {
      this.executionDateDisplay = '';
      return;
    }
    this.executionDateDisplay =
      ' (' +
      moment
        .tz(this.inputProduct.productPlacement.executionDate, 'Europe/Brussels')
        .format('DD/MM/YYYY') +
      ')';
  }

  getWithPlacement(): boolean {
    return this.inputProject.withPlacement;
    return false;
  }

  toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed;
    if (!this.collapsibleClicked) {
      this.collapsibleClicked = true;
      this.renderChildren.next(true);
    }
  }
}
